import { DomSanitizer } from '@angular/platform-browser'
import { Component, Input } from '@angular/core'
import { Colors } from '../../common/config/constants'
import { ContextService } from '../../services'

@Component({
  standalone: false,
  selector: 'app-pyramid-widget',
  templateUrl: './pyramid-widget.component.html',
  styleUrls: ['./pyramid-widget.component.scss'],
})
export class PyramidWidgetComponent {
  @Input() title = ''
  @Input() data = []
  @Input() isMultiple = false
  @Input() unit = ''
  @Input() description = ''
  @Input() highlight: string[] = []
  @Input() labels = []
  @Input() stats

  get referenceData(): any[] {
    if (!this.isMultiple) {
      return this.data || []
    }
    const refData = this.data[0]
    if (!refData) {
      return []
    }
    return Array.isArray(refData) ? refData : [refData]
  }

  get comparisonData(): any[] | null {
    if (!this.isMultiple) {
      return null
    }
    const cmpData = this.data[1]
    if (!cmpData) {
      return null
    }
    return Array.isArray(cmpData) ? cmpData : [cmpData]
  }

  get isVisitsAvailable() {
    return this.context.isVisitsAvailable()
  }

  constructor(
    private context: ContextService,
    private sanitizer: DomSanitizer,
  ) {}

  isNumber(value) {
    return !isNaN(Number(value))
  }

  getBackground(index) {
    const refPerc = 50 - this.referenceData[index].perc
    const compPerc = 50 + this.comparisonData[index].perc
    const css =
      `linear-gradient(to right, ` +
      `${Colors.colorN05}, ${Colors.colorN05} ${refPerc}%, ${Colors.colorAccent} ${refPerc}%, ` +
      `${Colors.colorAccent} 50%, ${Colors.colorSecondary} 50%, ` +
      `${Colors.colorSecondary} ${compPerc}%, ${Colors.colorN05} ${compPerc}%)`
    return this.sanitizer.bypassSecurityTrustStyle(css)
  }

  getPercentageTotalValue(elem) {
    const value = Number.parseInt(elem.value)
    return (value / this.stats) * 100
  }
}
